import { Plus } from '@tamagui/lucide-icons';
import { Button, ButtonProps } from '@unistocks/components/button/button';
import { quicker } from '@unistocks/shared/animations';
import React from 'react';
import Animated, { useAnimatedStyle, withSpring } from 'react-native-reanimated';
import { isWeb } from 'tamagui';

export type FloatingButtonProps = Omit<ButtonProps, 'variant'> & {
  open?: boolean;
};

export const FloatingButton: React.FC<FloatingButtonProps> = ({
  Icon = Plus,
  scaleIcon = 2.5,
  open,
  ...props
}) => {
  const rotateAnimation = useAnimatedStyle(() => {
    return !isWeb
      ? {
          transform: [
            {
              rotate: withSpring(`${open ? 135 : 0}deg`, quicker)
            }
          ]
        }
      : {};
  });

  return (
    <Button
      theme={'unistocksAlt'}
      size="$6"
      variant="fab"
      rotate={open && isWeb ? '135deg' : '0deg'}
      transition={'quickLessBouncy'}
      {...props}
    >
      <Animated.View style={rotateAnimation}>
        <Button.Icon scaleIcon={scaleIcon}>
          <Icon />
        </Button.Icon>
      </Animated.View>
    </Button>
  );
};

FloatingButton.displayName = 'FloatingButton';
